export default __webpack_public_path__ + "static/media/img3.d181f278.jpeg";